import React from 'react';
import { PieChart } from 'react-minimal-pie-chart';

interface ChartProps {
  get_table_data: Array<Record<string, any>>;
}

const CHART_COLORS = ['#0F766E', '#0284C7', '#CA8A04', '#B91C1C', '#7C3AED', '#6B7280', '#16A34A', '#EA580C'];

function getReadableTextColor(hexColor: string) {
  const hex = (hexColor || '').replace('#', '').trim();
  if (hex.length !== 6) return '#111827';
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 170 ? '#111827' : '#ffffff';
}

const Piechart = ({ get_table_data }: ChartProps) => {
  const pieData = get_table_data.map((item, index) => {
    return {
      id: item.rider,
      value: Number(item.count),
      title: item.name,
      color: CHART_COLORS[index % CHART_COLORS.length],
    };
  });

  return (
    <div className="flex flex-col items-center gap-3">
      <div style={{ width: 180, height: 180 }}>
        <PieChart
          label={({ dataEntry }) => dataEntry.title}
          labelPosition={70}
          labelStyle={(index: number) => ({
            fontSize: '5px',
            fill: '#111827',
            stroke: '#ffffff',
            strokeWidth: 0.8,
            paintOrder: 'stroke',
          })}
          animate={true}
          radius={40}
          lineWidth={40}
          data={pieData}
        />
      </div>
      {pieData.length > 0 && (
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs">
          {pieData.map((item, index) => (
            <div
              key={`${item.id ?? 'no-id'}-${item.title}-${index}`}
              className="flex items-center justify-between border border-gray-300 rounded px-2 py-1"
            >
              <span className="truncate mr-2">{item.id != null ? `${item.id}:${item.title}` : item.title}</span>
              <span className="font-semibold">{item.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Piechart;
